import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const newTripSegmentMessages = defineMessages({
  required: {
    id: 'bookings.edit.form.newTripSegment.required',
    defaultMessage: 'You need to select a new trip'
  }
})

const ticketsMessages = defineMessages({
  required: {
    id: 'bookings.edit.form.tickets.required',
    defaultMessage: `You need to select {min, plural,
      one {1 ticket}
      other {# tickets}
    }`
  }
})

export const schema = (intl: TSFixMe, oldTickets = [] as TSFixMe[]): TSFixMe => {
  return yup.object().shape({
    newTripSegment: yup.object().shape({
      id: yup.string().required(intl.formatMessage(newTripSegmentMessages.required))
    }),
    tickets: yup.array().min(oldTickets.length, ({ min }): TSFixMe => {
      return intl.formatMessage(ticketsMessages.required, {
        min
      })
    })
  })
}
